import React, { memo } from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';

import Icon from 'src/components/Icon/Icon';
import './BetDetails.scss';

interface BetDetailsProps {
  marketName: string,
  outcome: string,
  odds: number,
  index: number,
  oddsChanged: string
  selectedSlip: number,
  onBankerToggle: () => void,
  banker: boolean,
  showBanker: boolean
}

function BetDetails({ marketName, outcome, odds, index, oddsChanged, selectedSlip, showBanker, banker, onBankerToggle }: BetDetailsProps) {
  const dispatch = useDispatch();

  return (
    <div className="bet-details">
      {
        (selectedSlip === 2 || (selectedSlip === 1 && showBanker)) && (
          <span
            className={ classNames('bet-details__banker', { 'bet-details__banker--selected': banker }) }
            onClick={ onBankerToggle }
          >
                B
          </span>
        )
      }
      <div className="bet-details__market">
        <span className="bet-details__index">{ index +1 }.</span>
        <span className="bet-details__market-name">{ marketName }</span>
        <span className="bet-details__market-outcome">{ outcome } </span>
      </div>
      <div className="bet-details__odds-container">
        <span className={
          classNames({
            'bet-details__odds': true,
            'bet-details__odds--increased': oddsChanged === 'increased',
            'bet-details__odds--decreased': oddsChanged === 'decreased'
          })
        }
        >
          {
            oddsChanged &&
          <div className={
            classNames({
              'bet-details__arrow': true,
              'bet-details__arrow--up': oddsChanged === 'increased',
              'bet-details__arrow--down': oddsChanged === 'decreased'
            })
          }
          />
          }


          { odds == +odds ? odds : 'TP' }
        </span>
        <Icon icon="trash" className="bet-details__clear" onClick={ () => dispatch.betslip.removeBetAtIndex(index) } />
      </div>
    </div>
  );
}

export default memo(BetDetails);
